import React from "react";
import { Card } from "../components/card-home";
import "./style.css";

const HomePage = () => {
  return (
    <div className="home-body">
      <div className="cards">
        <Card
          title="Сэдвийн тест"
          description="Нийт 800 асуултыг сэдэв бүрээр нь ангилж бэлдсэн тест"
          href="/topic-test"
        />
        <Card
          title="Сэдвийн шалгалт"
          description="Улсын шалгалттай адилаар 20 минутын хугацаанд түүвэр 20 асуултанд хариулна"
          href="/exam-test"
        />
        <Card
          title="C, D ангиллын 200ш тест"
          description="Нэмэлт 200 асуултыг сэдэв бүрээр нь ангилж бэлдсэн тест"
          href="/additional-test"
        />
        <Card
          title="C, D ангилал - Шалгалт"
          description="Улсын шалгалттай адилаар 10 минутын хугацаанд түүвэр 10 асуултанд хариулна"
          href="/additional-exam-test"
        />
      </div>
    </div>
  );
};

export default HomePage;
